import {initialState} from "./initialState";

export default function inputReducer(state = initialState.victory, action) {
  switch (action.type) {
    default:
      return state;
  }
}
